export default __webpack_public_path__ + "media/images/icons_fc/key-943e47ba2507cfb67b71667b2d5d78b3.png";